import { CalendlyButton } from '../CalendlyButton/CalendlyButton';
import { StepperButton } from '../stepper-button/StepperButton';
import { Button } from '../utility/button/button';
export const HeaderCtaSection = (props: {
	ctaButtons: any[] | undefined;
	className: string;
	containsStartAQuoteButton: boolean | undefined;
	containsBookACallButton: boolean | undefined;
	heightVariant?: 'narrow';
	onClick?: () => void;
}) => {
	return (
		<div className={props.className} onClick={props.onClick}>
			{props.ctaButtons?.map((item, index) => {
				const f = item?.fields ?? item;
				return (
					<Button
						key={index}
						title={f.title}
						href={f.buttonUrl}
						textColor={f.textColour}
						backgroundColor={f.backgroundColour}
						borderColor={f.borderColour}
						isMenuButton={true}
						heightVariant={props.heightVariant}
						type={f.type}
						openInNewTab={f.openInNewTab ?? false}
					/>
				);
			})}
			{props.containsStartAQuoteButton && (
				<StepperButton
					title="Start a Quote"
					isMenuButton
					heightVariant={props.heightVariant}
				/>
			)}
			{props.containsBookACallButton && (
				<CalendlyButton
					title="Book a Call"
					isMenuButton
					heightVariant={props.heightVariant}
				/>
			)}
		</div>
	);
};
